import { useState } from "react";
import { toast } from "sonner";
import axios from "./axios";

export const useCampaignCard = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);

  const getCampaignCards = async () => {
    try {
      setLoading(true);
      const res = await axios.get("/audiences/campaign-card");
      if (res.status === 201) {
        setData(res.data.data);
      }
    } catch (err) {
      console.error("Campaign card error:", err);
      toast.error(
        err?.response?.data?.message || "Failed to load campaign cards"
      );
    } finally {
      setLoading(false);
    }
  };

  return { getCampaignCards, data, loading };
};
